import { el } from "@dhx/ts-common/dom";
import locale from "./locales/en";

export function selectAllView() {
	return el(
		".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all",
		locale.selectAll
	);
}

export function unselectAllView() {
	return el(
		".dhx_list-item.dhx_combobox-options__item.dhx_combobox-options__item--select-all.dhx_combobox__action-select-all",
		locale.unselectAll
	);
}

export function emptyListView(value?: string) {
	return el("ul.dhx_list", [
		el(
			`li.dhx_list-item.dhx_combobox-options__item${
				value ? ".dhx_combobox-options__action-create-option" : ""
			}`,
			{},
			value ? `${locale.createItem} "${value}"` : locale.notFound
		),
	]);
}

export function emptyListHeight(value: string, width: number) {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d", {
		alpha: false,
	});
	ctx.font = "normal 14px Roboto";

	const sumValue = value ? `${locale.createItem} "${value}"` : locale.notFound;
	return 13 + 20 * Math.ceil(ctx.measureText(sumValue).width / (width - 16));
}
